import React from "react";

const roleBadgeColor = (role) => {
  switch (role) {
    case "owner": return { bg: "#fef3c7", color: "#92400e" };
    case "admin": return { bg: "#dbeafe", color: "#1e40af" };
    default: return { bg: "#e5e7eb", color: "#374151" };
  }
};

const CashierProfileView = ({
  user,
  profile,
  role,
  shiftStartTime,
  todaySalesCount,
  todaySalesTotal,
  onLock,
  onLogout,
  onNavigate,
}) => {
  const displayName = profile?.full_name || user?.user_metadata?.full_name || user?.email || "Caissier";
  const email = user?.email || "";
  const badge = roleBadgeColor(role);

  const formatTime = (iso) => {
    if (!iso) return "--:--";
    try {
      return new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
    } catch {
      return "--:--";
    }
  };

  const formatCurrency = (n) => {
    return Number(n || 0).toFixed(2) + " €";
  };

  return (
    <div className="p-4 h-100 d-flex flex-column text-white">
      {/* Tabs row */}
      <div className="d-flex justify-content-around border-bottom pb-3 mb-4" style={{ borderColor: "var(--pos-line)" }}>
        <div
          className="text-center pos-menu-item is-active"
          role="button"
          tabIndex={0}
        >
          <i className="bi bi-person-circle fs-1"></i><br/>CAISSIER
        </div>
        <div
          className="text-center pos-menu-item opacity-75"
          role="button"
          tabIndex={0}
          onClick={() => onNavigate && onNavigate("default")}
        >
          <i className="bi bi-cash-coin fs-1"></i><br/>CAISSE
        </div>
        <div className="text-center pos-menu-item opacity-75">
          <i className="bi bi-gear-fill fs-1"></i><br/>MATÉRIEL
        </div>
      </div>

      {/* Profile Card */}
      <div className="d-flex flex-column align-items-center gap-3 w-100" style={{ maxWidth: "320px", margin: "0 auto" }}>
        {/* Avatar */}
        <div
          className="rounded-circle d-flex align-items-center justify-content-center fw-bold"
          style={{
            width: "80px",
            height: "80px",
            fontSize: "2rem",
            backgroundColor: "rgba(255,255,255,0.15)",
            border: "3px solid rgba(255,255,255,0.3)",
          }}
        >
          {displayName.charAt(0).toUpperCase()}
        </div>

        {/* Name */}
        <div className="text-center">
          <div className="fw-bold fs-5">{displayName}</div>
          {email && <div className="opacity-75" style={{ fontSize: "0.8rem" }}>{email}</div>}
        </div>

        {/* Role Badge */}
        <span
          className="badge rounded-pill px-3 py-1 fw-semibold"
          style={{ backgroundColor: badge.bg, color: badge.color, fontSize: "0.75rem" }}
        >
          {(role || "caissier").toUpperCase()}
        </span>

        {/* Shift Info */}
        <div className="w-100 mt-2 p-3 rounded-3" style={{ backgroundColor: "rgba(255,255,255,0.08)" }}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="opacity-75" style={{ fontSize: "0.85rem" }}>
              <i className="bi bi-clock me-1"></i> Début de shift
            </span>
            <span className="fw-semibold">{formatTime(shiftStartTime)}</span>
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <span className="opacity-75" style={{ fontSize: "0.85rem" }}>
              <i className="bi bi-receipt me-1"></i> Ventes aujourd'hui
            </span>
            <span className="fw-semibold">
              {todaySalesCount} <span className="opacity-50">|</span> {formatCurrency(todaySalesTotal)}
            </span>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="d-flex flex-column gap-2 w-100 mt-3">
          <button
            className="btn btn-outline-light w-100 d-flex align-items-center justify-content-center gap-2"
            style={{ borderRadius: "10px", borderWidth: "2px" }}
            onClick={onLock}
          >
            <i className="bi bi-lock-fill"></i>
            Verrouiller
          </button>
          <button
            className="btn w-100 d-flex align-items-center justify-content-center gap-2"
            style={{
              borderRadius: "10px",
              backgroundColor: "rgba(239,68,68,0.15)",
              color: "#fca5a5",
              borderWidth: "2px",
              borderColor: "rgba(239,68,68,0.3)",
            }}
            onClick={onLogout}
          >
            <i className="bi bi-box-arrow-right"></i>
            Déconnexion
          </button>
        </div>
      </div>
    </div>
  );
};

export default CashierProfileView;
